import React from "react";
import {
  ServicesSection,
  ServicesContainer, // Ajoutez cette importation
  ServicesHeader,
  TitleTag,
  Title,
  Description,
  ServicesGrid,
  ServiceItem,
  IconBox,
  ServiceText,
  ServiceTitle,
  ServiceDescription,
  ScrollDown,
  ScrollDownContainer,
  Divider
} from "./Services.styles";
import Audiovisuel from "../../assets/audiovisuel.png";
import Branding from "../../assets/branding.png";
import Graphisme from "../../assets/graphisme.png";
import RegiePub from "../../assets/publicite.png";
import SocialMedia from "../../assets/socialmedia.png";
import Numerique from "../../assets/numerique.png";

import { FaAngleDown } from "react-icons/fa6";

const Services = () => {
  return (
    <ServicesSection id="services">
      <ServicesContainer> {/* Ajoutez ce conteneur */}
        <ServicesHeader>
          <TitleTag>Nos</TitleTag>
          <Title>Services</Title>
          <Description>
            Lorem ipsimus , take the minimum &nbsp; Nous sommes là pour vous accompagner en :
          </Description>
        </ServicesHeader>

        <ServicesGrid>
          <ServiceItem>
            <IconBox>
              <img 
                src={Numerique} 
                alt="Numérique" 
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
            </IconBox>
            <ServiceText>
              <ServiceTitle>Numérique</ServiceTitle>
              <ServiceDescription>
                Gestion et animation des vos réseaux par des stratégies de communication efficaces
                pour valoriser votre image et vos projets.
              </ServiceDescription>
              <Divider />
            </ServiceText>
          </ServiceItem>

          <ServiceItem>
            <IconBox>
              <img 
                src={SocialMedia} 
                alt="Social media" 
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
            </IconBox>
            <ServiceText>
              <ServiceTitle>Social media</ServiceTitle>
              <ServiceDescription>
                Gestion et animation des vos réseaux par des stratégies de communication efficaces
                pour valoriser votre image et vos projets.
              </ServiceDescription>
              <Divider />
            </ServiceText>
          </ServiceItem>

          <ServiceItem>
            <IconBox>
              <img 
                src={Audiovisuel} 
                alt="Audiovisuel" 
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
            </IconBox>
            <ServiceText>
              <ServiceTitle>Audiovisuel</ServiceTitle>
              <ServiceDescription>
                Production de contenus visuels et vidéos à fort impact émotionnel racontant votre
                histoire autrement.
              </ServiceDescription>
              <Divider />
            </ServiceText>
          </ServiceItem>

          <ServiceItem>
            <IconBox>
              <img 
                src={Branding} 
                alt="Branding" 
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
            </IconBox>
            <ServiceText>
              <ServiceTitle>Branding</ServiceTitle>
              <ServiceDescription>
                Construction et valorisation d'identités de marques fortes et mémorables, suscitant la
                confiance, la reconnaissance et l'attachement.
              </ServiceDescription>
              <Divider />
            </ServiceText>
          </ServiceItem>

          <ServiceItem>
            <IconBox>
              <img 
                src={Graphisme} 
                alt="Graphisme" 
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
            </IconBox>
            <ServiceText>
              <ServiceTitle>Graphisme</ServiceTitle>
              <ServiceDescription>
                Création de visuels sur mesure pour une identité forte et cohérente alliant innovation
                et incluant l'essence de votre marque.
              </ServiceDescription>
              <Divider />
            </ServiceText>
          </ServiceItem>

          <ServiceItem>
            <IconBox>
              <img 
                src={RegiePub} 
                alt="Régie publicitaire" 
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
            </IconBox>
            <ServiceText>
              <ServiceTitle>Régie publicitaire</ServiceTitle>
              <ServiceDescription>
                Gestion, planification et diffusion de campagnes publicitaires multicanal pour un
                meilleur retour sur investissement.
              </ServiceDescription>
              <Divider />
            </ServiceText>
          </ServiceItem>
        </ServicesGrid>
        
        <ScrollDownContainer>
          <ScrollDown>
            <FaAngleDown />
          </ScrollDown>
          <ScrollDown className="second-arrow">
            <FaAngleDown />
          </ScrollDown>
        </ScrollDownContainer>
      </ServicesContainer> {/* Fermez le conteneur */}
    </ServicesSection>
  );
};

export default Services;